import * as React from 'react';
import { Redirect } from 'react-router';
import { paths } from '../../app/constants';

export interface RestrictedComponentProps {
    isLoggedIn: boolean;
    hasPermission: boolean;
    children: React.ReactElement,
    notPermitted?: React.ReactElement,
}

const RestrictedComponent: React.FC<RestrictedComponentProps> = (props) => {
    const {
        isLoggedIn,
        hasPermission,
        children,
        notPermitted,
    } = props;

    if(!isLoggedIn) return (<Redirect to={paths.login()}/>);
    if(hasPermission) return children;
    return notPermitted || null;
}

export default RestrictedComponent;